import { jsx as _jsx } from "react/jsx-runtime";
import DisclaimerContainer from '../DisclaimerContainer';
import ErrorComponent from './ErrorComponent';
const ErrorPage = ({ error }) => {
    return (_jsx(DisclaimerContainer, { children: _jsx(ErrorComponent, { error: error }) }));
};
export default ErrorPage;
